import React from 'react';
import { AwardIcon, HandshakeIcon, LanguagesIcon, ShieldCheckIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { SectionHeading } from '../components/SectionHeading';
import { CtaBand } from '../components/CtaBand';
import { Stars } from '../components/Stars';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import { copy } from '../data/copy';
const commitmentIcons = [ShieldCheckIcon, HandshakeIcon, AwardIcon, LanguagesIcon];
export function About() {
  const {
    t
  } = useLanguage();
  const page = copy.pages.about;
  return <>
      <Seo title={t(copy.seo.about.title)} description={t(copy.seo.about.description)} data-id="element-330" data-mp="2x8y4cikdo8ku" />
      <PageHeader eyebrow={t(page.eyebrow)} title={t(page.title)} description={t(page.description)} data-id="element-331" data-mp="1guooydy45u65" />

      <section className="bg-white py-16 sm:py-20" data-id="element-332" data-mp="1lvm40hntu83f">
        <div className="mx-auto grid max-w-7xl items-start gap-12 px-6 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16" data-id="element-333" data-mp="1uhigjk3kou8a">
          <div data-id="element-334" data-mp="1pjgv4siocitn">
            <SectionHeading title={t(page.storyTitle)} data-id="element-335" data-mp="1pjqjkbo2mhx8" />
            <div className="mt-6 space-y-5 text-lg leading-relaxed text-navy-600" data-id="element-336" data-mp="23igkk2e0h1qv">
              {page.story.map(paragraph => <p key={paragraph.en} data-id="element-337" data-mp="1yic1c4lpxswy">{t(paragraph)}</p>)}
            </div>

            <div className="mt-10 grid gap-6 border-t border-navy-100 pt-8 sm:grid-cols-3" data-id="element-338" data-mp="2dfuo51eu5w1r">
              <div data-id="element-339" data-mp="28i2yyf5kso19">
                <p className="font-display text-3xl font-bold text-navy-900" data-id="element-340" data-mp="28gi4sqn6b73x">
                  {business.rating}★
                </p>
                <p className="mt-1 text-sm text-navy-600" data-id="element-341" data-mp="2mb2a64ybrw30">
                  {t(page.statRating)}
                </p>
                <Stars rating={business.rating} className="mt-2" data-id="element-342" data-mp="2w75cpbx39wqh" />
              </div>
              <div data-id="element-343" data-mp="2w516uofmqnnk">
                <p className="font-display text-3xl font-bold text-navy-900" data-id="element-344" data-mp="2r8av2dauye7y">
                  {business.reviewCount}
                </p>
                <p className="mt-1 text-sm text-navy-600" data-id="element-345" data-mp="1ovxu9wrqyyea">
                  {t(page.statReviews)}
                </p>
              </div>
              <div data-id="element-346" data-mp="1stvk91tcdoiq">
                <p className="font-display text-3xl font-bold text-navy-900" data-id="element-347" data-mp="1xvkyeqbv2ib1">
                  2
                </p>
                <p className="mt-1 text-sm text-navy-600" data-id="element-348" data-mp="22mb2m08jwf45">
                  {t(page.statLanguages)}
                </p>
              </div>
            </div>
          </div>

          <div className="grid gap-4" data-id="element-349" data-mp="2ck79gfuggnwg">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/bc07183d-a2d8-4a27-a45c-85a8576030e2.jpg" alt="The A&J Auto Repair team standing in front of an open service bay" className="w-full rounded-xl object-cover ring-1 ring-navy-100" data-id="element-350" data-mp="2cj61wlcnejjh" />
            <div className="grid grid-cols-2 gap-4" data-id="element-351" data-mp="m92ya03ayn76">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/deb7d939-8889-447c-a17d-f7585bdb4bf9.jpg" alt="A&J Auto Repair shop exterior on Pulaski Highway" loading="lazy" className="aspect-[4/3] w-full rounded-xl object-cover ring-1 ring-navy-100" data-id="element-352" data-mp="r6mdb27tr406" />
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/5dcc1146-3f52-4c0e-b554-883203821ec3.jpg" alt="Clean service bays with vehicle lifts inside the shop" loading="lazy" className="aspect-[4/3] w-full rounded-xl object-cover ring-1 ring-navy-100" data-id="element-353" data-mp="9y3bfs0kbkmh" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-navy-50 py-16 sm:py-20" data-id="element-354" data-mp="sq4k1m352p93">
        <div className="mx-auto max-w-7xl px-6" data-id="element-355" data-mp="on7v7dn09wwp">
          <SectionHeading title={t(page.commitmentsTitle)} description={t(page.commitmentsDescription)} data-id="element-356" data-mp="ooiyzdggb4nt" />
          <div className="mt-12 grid gap-x-10 gap-y-10 sm:grid-cols-2" data-id="element-357" data-mp="39c5m920csp9o">
            {page.commitments.map((item, index) => {
            const Icon = commitmentIcons[index];
            return <article key={item.title.en} className="flex gap-4" data-id="element-358" data-mp="15uz349jluafw" data-mpi={index}>
                  <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-white text-gold-600 ring-1 ring-navy-100" data-id="element-359" data-mp="r5t86xrsv6dt">
                    <Icon width={24} height={24} aria-hidden="true" data-id="element-360" data-mp="w5nyp07nxtyc" />
                  </span>
                  <div data-id="element-361" data-mp="1jvs0r357dln8">
                    <h3 className="font-display text-lg font-bold text-navy-900" data-id="element-362" data-mp="1jv9t7ad3bl00">
                      {t(item.title)}
                    </h3>
                    <p className="mt-2 leading-relaxed text-navy-600" data-id="element-363" data-mp="1aubp6s2njdhf">
                      {t(item.body)}
                    </p>
                  </div>
                </article>;
          })}
          </div>
        </div>
      </section>

      <CtaBand data-id="element-364" data-mp="3viq0n6dtntjj" />
    </>;
}